<template>
  <div>
    <Headersys />
    <div class="content">
      <div>
        <div
          class="back-btn"
          @click="backCurrent"
          v-if="listCurrent.length > 1"
        >
          返回
        </div>
      </div>
      <div class="file-box">
        <div
          class="file-item"
          v-for="item in fileList"
          :key="item.fileName"
          @click="chooseTab(item.filePath)"
        >
          <img
            class="file-img"
            src="../../assets/images/PDF.png"
            alt=""
            v-if="item.type == 'pdf'"
          />
          <img
            class="file-img"
            src="../../assets/images/WORD.png"
            alt=""
            v-else-if="item.type == 'word'"
          />
          <img
            class="file-img"
            src="../../assets/images/IMG.png"
            alt=""
            v-else-if="item.type == 'img'"
          />
          <img
            class="file-img"
            src="../../assets/images/WJJ.png"
            alt=""
            v-else
          />
          <div class="file-name">
            {{ item.fileName }}
          </div>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back />
  </div>
</template>
<script>
import { Loading } from "element-ui";
export default {
  name: "",
  data() {
    return {
      //
      fileList: [],
      waitTime: 290,
      watiTimer: null,
      printTotal: 0,
      maskShow: false,
      loadingInstance: null,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      listCurrent: [], //目录
    };
  },
  created() {
    //
  },
  mounted() {
    //
    this.redUsb("");
    this.timeDown();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
    this.checkPrintCurrent();
  },
  beforeDestroy() {
    // console.log('清除定时器');
    clearTimeout(this.watiTimer);
  },
  methods: {
    chooseTab(path) {
      if (path.includes(".")) {
        this.printFile(path);
      } else {
        this.redUsb(path);
      }
    },
    //读取U盘
    redUsb(uDiskPath) {
      this.listCurrent.push(uDiskPath);
      const formData = new FormData();
      formData.append("uDiskPath", uDiskPath);
      this.$rqt.common_readUSB(formData).then((res) => {
        var list = res.data;
        // console.log(list);
        list.forEach((el) => {
          if (el.fileName.includes(".pdf")) {
            el.type = "pdf";
          }
          if (el.fileName.includes(".doc")) {
            el.type = "word";
          }
          if (
            el.fileName.includes(".png") ||
            el.fileName.includes(".jpeg") ||
            el.fileName.includes(".jpg")
          ) {
            el.type = "img";
          }
        });
        this.fileList = list;
      });
    },
    backCurrent() {
      const formData = new FormData();
      var path;
      console.log(this.listCurrent.length);
      if (this.listCurrent.length > 1) {
        path = this.listCurrent.length - 2;
      } else {
        path = this.listCurrent.length - 1;
      }
      this.listCurrent.pop();
      formData.append("uDiskPath", this.listCurrent[path]);
      this.$rqt.common_readUSB(formData).then((res) => {
        var list = res.data;
        list.forEach((el) => {
          if (el.fileName.includes(".pdf")) {
            el.type = "pdf";
          }
          if (el.fileName.includes(".doc")) {
            el.type = "word";
          }
          if (
            el.fileName.includes(".png") ||
            el.fileName.includes(".jpeg") ||
            el.fileName.includes(".jpg")
          ) {
            el.type = "img";
          }
        });
        this.fileList = list;
      });
    },
    // 打印
    printFile(path) {
      this.maskShow = true;
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在打印...",
          target: document.querySelector("#loadDom"),
        });
      }, 500);
      const formData = new FormData();
      formData.append("filePath", path);
      formData.append("upperBound", this.printTotal);
      this.$rqt.common_printFile(formData).then((res) => {
        console.log(res);
        var page = res.data;
        this.savePrintRecord(page); //保存打印页数
        this.printTotal = this.printTotal - page;
        setTimeout(() => {
          this.loadingInstance.close();
          this.maskShow = false;
        }, 2000);
        if (this.printTotal <= 0) {
          this.messageToast("单人每天限制打印10张");
          return;
        }
      });
    },
    // 保存打印记录
    savePrintRecord(count) {
      for (let index = 0; index < count; index++) {
        this.$rqt.print_save({
          type: "上传打印",
          fmac: this.fmac,
          name: this.name,
          phone: this.phone,
          idCard: this.idCard,
        });
      }
    },
    // 检查剩余打印次数
    checkPrintCurrent() {
      this.$rqt
        .print_getPrintLastNumber({
          idCard: this.idCard,
          type: "上传打印",
        })
        .then((res) => {
          this.printTotal = 10 - res.data;
          console.log("剩余打印次数", this.printTotal);
        });
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 290;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  position: relative;
}

.back-btn {
  font-size: 7rem;
}

.file-box {
  height: calc(100vh - 49rem - 40px);
  overflow-y: scroll;
}

.file-box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.file-item {
  width: 10%;
  float: left;
  margin: 10px 20px;
  text-align: center;
  font-size: 5rem;
}

.file-img {
  width: 100%;
  display: block;
}

.file-name {
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏超出容器的文本 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: red;
}
</style>